import { BoolEquals } from '@vendasta/automata';
import { IsEmptyOptionsComponent } from './dynamic-options/is-empty-options/is-empty-options.component';
import { IsEmptyOptionsDisplayService } from './dynamic-options/is-empty-options/is-empty-options-display.service';
import { DataFilter } from './interface';

const SHOPPING_CART_HAS_ITEMS = '{.has_items}';
export class ShoppingCartHasItems implements DataFilter {
  rules = [new BoolEquals(SHOPPING_CART_HAS_ITEMS)];
  dataEntryComponent = IsEmptyOptionsComponent;
  displayService = IsEmptyOptionsDisplayService;
  label = 'AUTOMATIONS.EDITOR.FILTERS.SHOPPING_CART_CONTENTS.DATA_LABELS.ITEMS';
  comparisonLabels = ['AUTOMATIONS.EDITOR.FILTERS.SHOPPING_CART_CONTENTS.COMPARISON.ARE'];
}

export const SHOPPING_CART_CONTENTS_COMPONENTS: Map<string, DataFilter> = new Map<string, DataFilter>([
  [SHOPPING_CART_HAS_ITEMS, new ShoppingCartHasItems()],
]);
